// extracted by mini-css-extract-plugin
module.exports = {"title":"styles__title___30pMZ","linkTitle":"styles__linkTitle___3bUnv styles__title___30pMZ"};